import "./CustomSwitch.css";

const CustomSwitch = ({ setSwitch, isSwitch, disabled = false }) => {
  return (
    <div>
      <label className={`switch ${disabled ? "switch-disabled" : ""}`}>
        <input
          disabled={disabled}
          type="checkbox"
          checked={isSwitch}
          onChange={(e) => setSwitch(e.target.checked)}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default CustomSwitch;
